// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/section/confirmation/confirmation.scss
 ** module id = 188
 ** module chunks = 0 1
 **/